// frontend/src/lib/report.js
import { SEVERITY, SEVERITY_ORDER } from "./theme";

export function buildEmailBody(result) {
  const { domain, score, grade, summary, counts, categories, scanned_at, scan_id } = result;
  const lines = [];

  lines.push(`CyberCheck website security report`);
  lines.push(`Domain:   ${domain}`);
  if (scan_id) lines.push(`Scan ID:  ${scan_id}`);
  lines.push(`Score:    ${score}/100 (Grade ${grade})`);
  lines.push(`Scanned:  ${new Date(scanned_at).toLocaleString()}`);
  lines.push("");
  lines.push(`Summary:  ${summary}`);
  lines.push("");
  lines.push("Findings by severity:");
  for (const s of SEVERITY_ORDER) {
    if (counts[s]) lines.push(`  ${counts[s]} ${SEVERITY[s].label}`);
  }
  lines.push("");
  lines.push("─".repeat(60));
  lines.push("");

  for (const cat of categories) {
    const issues = cat.findings.filter((f) => f.severity !== "pass");
    if (!issues.length) continue;
    lines.push(`## ${cat.label}  (${cat.score}/100)`);
    lines.push("");
    for (const f of issues) {
      lines.push(`[${(f.severity || "info").toUpperCase()}] ${f.title}`);
      if (f.what) lines.push(`  What:  ${f.what}`);
      if (f.why) lines.push(`  Why:   ${f.why}`);
      if (f.fix) lines.push(`  Fix:   ${f.fix}`);
      if (f.evidence) lines.push(`  Proof: ${f.evidence}`);
      lines.push("");
    }
  }

  lines.push("─".repeat(60));
  lines.push(
    "These are security-readiness indicators, not a penetration test or a security guarantee."
  );
  lines.push("Generated by CyberCheck.");
  return lines.join("\n");
}

export function mailtoReport(result) {
  const subject = `Security report for ${result.domain} — Grade ${result.grade}`;
  const body = buildEmailBody(result);
  const encoded = encodeURIComponent(body).slice(0, 1800);
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encoded}`;
}

export function whatsappShareUrl(result) {
  const text =
    `CyberCheck scan for ${result.domain}\n` +
    `Score: ${result.score}/100 (Grade ${result.grade})\n` +
    `${result.summary}\n\n` +
    `Full report: ${typeof window !== "undefined" ? window.location.href : ""}`;
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}